import { render, staticRenderFns } from "./IdentificationPlaceInput.vue?vue&type=template&id=565611e1&"
import script from "./IdentificationPlaceInput.vue?vue&type=script&lang=js&"
export * from "./IdentificationPlaceInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports